import { AxiosError } from "axios";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  ICompanyAddDepositAccountsRequestBody,
  ICompanyAddDepositAccountsResponseBody,
} from "../companyAddDepositAccounts/companyAddDepositAccounts.schema";

export const ensureCompanyApplications =
  (axios: IAxiosInstance) =>
  async (body: ICompanyAddDepositAccountsRequestBody) => {
    try {
      const response =
        await axios.noRetry.post<ICompanyAddDepositAccountsResponseBody>(
          `/api/company/ensure-company-applications`,
          body
        );
      return response;
    } catch (e) {
      const errorMessage =
        (e as AxiosError)?.response?.data ??
        "Error ensuring company applications";
      throw errorMessage;
    }
  };
